<template>
  <div class="row">
    <div class="grid-6">
      <input-number v-on:update-value="updateValue" min="0" max="120" v-bind:value="hours"  v-model.number="hours" model="hours" label="Hours"></input-number>
    </div>
    <div class="grid-6">
      <input-number v-on:update-value="updateValue" min="0" max="59" v-bind:value="minutes"  v-model.number="minutes" model="minutes" v-on:hit-minute-max="hitMinuteMax"  v-on:hit-minute-min="hitMinuteMin" label="Minutes"></input-number>
    </div>
  </div>
</template>

<script>
import InputNumber from './InputNumber';
export default {
  name: 'time-input',
  components: {InputNumber},
  props: ['model', 'value'],
  data() {
    return {
      hours: 12,
      minutes: 48
    }
  },
  methods: {
    updateValue(model, value) {
      this[model] = Number(value)
      let timeInSeconds = (this.minutes * 60) + (this.hours * 60 * 60)
      this.$emit('update-value', this.model, timeInSeconds)
    },
    hitMinuteMax(value) {
      this.minutes = 0
      this.hours = this.hours + 1
      let timeInSeconds = (this.minutes * 60) + (this.hours * 60 * 60)
      this.$emit('update-value', this.model, timeInSeconds)
    },
    hitMinuteMin(value) {
      this.minutes = 59
      this.hours = this.hours - 1
      let timeInSeconds = (this.minutes * 60) + (this.hours * 60 * 60)
      this.$emit('update-value', this.model, timeInSeconds)
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// InputTime.vue?675adb90